import { useErrorToast } from "../useErrorToast"
import { useSuccessToast } from "../useSuccessToast"

export function useConfiguredToasts() {
  return {
    displayErrorToast: useErrorToast(),
    displaySuccessToast: useSuccessToast(),
  }
}
